function isPlain(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

function mergeDeep(base: Record<string, unknown>, extra: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = { ...base };
  for (const [key, value] of Object.entries(extra)) {
    if (isPlain(out[key]) && isPlain(value)) {
      out[key] = mergeDeep(out[key] as Record<string, unknown>, value);
    } else {
      out[key] = value;
    }
  }
  return out;
}

const modules = {
  ...import.meta.glob('./*/*.ts', { eager: true }),
  ...import.meta.glob('./*/*.json', { eager: true }),
};

const messages: Record<string, { translation: Record<string, unknown> }> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.(?:ts|json)$/);
  if (!match) return;
  const [, lang] = match;
  const module = modules[path] as { default?: Record<string, unknown> };
  if (!messages[lang]) {
    messages[lang] = { translation: {} };
  }
  if (module.default) {
    messages[lang].translation = mergeDeep(messages[lang].translation, module.default);
  }
});

export default messages;
